import { styled } from '@mui/material/styles';
import { Box, Chip, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const ChipsContainer = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 8,
  minHeight: 35,
  marginTop: 12
});

export const StyledChip = styled(Chip)({
  backgroundColor: '#fff',
  '& .MuiChip-label': {
    display: 'flex',
    alignItems: 'center'
  }
});

export const DeleteIconButton = styled(IconButton)({
  padding: 4
});

export const ChipDeleteIcon = styled(CloseIcon)({
  color: '#0000008a'
});
